module.exports = __webpack_public_path__ + "static/SmartShoePicV1-d51a36098066bcf04612e33ee093a6cd.jpg";